<script setup>
import Modal from "@/components/modal/Modal";
import QRCodeVue3 from "qrcode-vue3";

const props = defineProps({
    url: {
        type: String,
        required: true
    },
    testPassword: {
        type: String,
        required: true
    }
})

const emit = defineEmits(['close'])

</script>

<template>
    <Modal @close="emit('close')" :closeOnClickOutside="false">
        <v-container>
            <v-row>
                <v-col cols="12" class="d-flex flex-column ga-1 align-center">
                    <h1>Naskenujte fotoaparátem</h1>
                    <QRCodeVue3
                        :value="url"
                    />
                    <h3>{{ url }}</h3>
                    <h3>{{ pgettext('label', 'password') }}: {{ testPassword }}</h3>
                </v-col>
            </v-row>
        </v-container>
    </Modal>
</template>

<style scoped>

</style>